export const ZAKAT_MULTIPLIER = 0.025;
export const DEFAULT_GOLD_PRICE = 40.67;
export const DEFAULT_SILVER_PRICE = 19.137;
export const DEFAULT_NISAB_PRICE = 367.42;
